module.exports = __webpack_public_path__ + "img/check_trgl.da2db483.svg";